import { types } from './actions';

const initialState = {
  quoteViews: [],
  isFetching: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.FETCH_QUOTE_VIEWS_ERRORS:
      return {
        ...state,
        isFetching: false,
      };
    case types.FETCH_QUOTE_VIEWS_REQUEST:
      return {
        ...state,
        quoteViews: [],
        isFetching: true,
      };
    case types.FETCH_QUOTE_VIEWS_SUCCESS:
      return {
        ...state,
        quoteViews: payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.common.modals.quoteViewsModal;

export const getAreQuoteViewsFetching = (state) => getScope(state).isFetching;

export const getQuoteViews = (state) => getScope(state).quoteViews;

export default reducer;
